<template>
  <DataTable
    url="users"
    edit-url="edit-user-form"
    assign-roles-url="users-assign-roles"
    disable-user="true"
  />
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "user-index",
  emits: ["setBreadcrumb"],
  components: { DataTable },
  data() {
    return {
      breadcrumb: [{ text: "Usuarios", link: { name: "users" } }],
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
